/**
 * This bit of code here is a little strange... You can't use Node.js
 * environment variables in client-side JavaScript. But, this file isn't
 * served to the client directly, it is pre-processed by webpack during
 * the build process. Therefore, we can use this little trick to switch out
 * production and development API hosts. Use this trick with caution.
 *
 * See https://github.com/facebookincubator/create-react-app/blob/master/packages/react-scripts/template/README.md#adding-custom-environment-variables
 * for more information.
 */
var HOST;
// eslint-disable-next-line
if (process.env.REACT_APP_ENV == 'production') {
  HOST = 'https://pcmh-api.evolutionaryhealthsolutions.com';
}
// eslint-disable-next-line
else if (process.env.REACT_APP_ENV == 'test') {
  HOST = 'https://pcmh-test-api.evolutionaryhealthsolutions.com';
} else {
  HOST = 'http://localhost:8081';
}
// console.log(`Using ${process.env.NODE_ENV} API host: ${HOST}`);

export default {
  AUTH_SIGIN_IN: `${HOST}/user/auth/signin`,
  BILLING_BASE: `${HOST}/billing`,
  ORGANIZATION_BASE: `${HOST}/organization`,
  PRACTICE_BASE: `${HOST}/practice`,
  REFRESH_TOKEN: `${HOST}/user/refreshToken`,
};



// WEBPACK FOOTER //
// ./src/api/endpoints.js